import { mediaData } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">精彩预告</h2>
          <p className="text-sm text-foreground-500 mt-2">精选热门电视剧推荐，发现你的下一部必追好剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full">
                    {item.hotLabel}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-white/80 text-xs">{item.category}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-sm text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaData.slice(3, 5).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full">
                    {item.hotLabel}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-white/80 text-xs">{item.category}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-sm text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}